module.exports = __webpack_public_path__ + "img/banner_pdf_zoo.bccee963.jpg";